import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { IncentiveShiftOverride } from "../models/IncentiveShiftOverride";
import { updateShiftOverride } from "../repositories/IncentiveRepository";

export const useUpdateShiftOverride = () => {
	const queryClient = useQueryClient();

	return useMutation(
		(payload: IncentiveShiftOverride) => updateShiftOverride(payload),
		{
			onSuccess: async () => {
				// Immediate local refresh for the user who made the change.
				// SignalR will also fire (via QueryCacheInvalidations) for other tabs/users;
				// TanStack Query deduplicates if both arrive while a fetch is in-flight.
				await Promise.all([
					queryClient.invalidateQueries({ queryKey: ["incentive"] }),
					queryClient.invalidateQueries({ queryKey: ["incentive-report"] }),
				]);
			},
		},
	);
};
